import React from 'react';
import Card from '@components/card';
import { IconFace, IconCamera } from '@yoti/ui-kit-components-react/globals';
import styles from './Home.module.scss';
import { useNavigate } from 'react-router-dom';
import { HeaderTab } from '@components/commons';
import { AGE_ANTISPOOFING_PATH } from '@utils/constants/Routes';

interface PanelConfiguration {
    title: string;
    iconComponent: React.ReactNode;
    path: string;
}

export const panelsConfiguration: PanelConfiguration[] = [
    {
        title: 'Age & Antispoofing',
        iconComponent: <IconCamera className={styles['home__icon']} />,
        path: AGE_ANTISPOOFING_PATH,
    },
    {
        title: 'Face Matching',
        iconComponent: (
            <div className={styles['home__face-matching']}>
                <IconFace className={styles['home__icon']} />
                <IconFace className={styles['home__icon']} />
            </div>
        ),
        path: 'face-matching',
    },
];

const Home: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div>
            <HeaderTab className={styles['home__tab']} tabs={['Select tool']}></HeaderTab>
            <div className={styles['home__cards-container']}>
                {panelsConfiguration.map((p, i) => {
                    return (
                        <Card
                            key={`${p.path}-${i}`}
                            title={p.title}
                            onClick={() => navigate(p.path)}
                        >
                            {p.iconComponent}
                        </Card>
                    );
                })}
            </div>
        </div>
    );
};

export default Home;
